import { render, staticRenderFns } from "./donation-in-honor.vue?vue&type=template&id=52947192&"
import script from "./donation-in-honor.vue?vue&type=script&lang=js&"
export * from "./donation-in-honor.vue?vue&type=script&lang=js&"
import style0 from "./donation-in-honor.vue?vue&type=style&index=0&id=52947192&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports